export const dateParser = (v: string): string | null => {
  try {
    const date = new Date(v);
    const utcDate = date.toISOString();
    return utcDate.slice(0, -5);
  } catch (error) {
    return null;
  }
};
